import { getRelay } from "./loader";

/**
 * Fires a page view event into the relay.
 * No-ops silently if the relay is disabled or not yet loaded.
 */
export function trackPageView(url: string): void {
  if (!IS_CAT_ENABLED) {
    return;
  }

  const relay = getRelay();
  if (!relay) {
    return;
  }

  relay.trackPageView(url);
}
